import { render } from "./AmeliorationView.vue?vue&type=template&id=22ab46bd&scoped=true"
import script from "./AmeliorationView.vue?vue&type=script&lang=js"
export * from "./AmeliorationView.vue?vue&type=script&lang=js"

import "./AmeliorationView.vue?vue&type=style&index=0&id=22ab46bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ab46bd"]])

export default __exports__